import React, { useContext } from 'react';
import { Box, Icon, Tooltip } from '@chakra-ui/react';
import { Flex, Text } from '@chakra-ui/layout';
import PersonaThumbnail from './personaThumbnail';
import { PersonaContext } from '../lib/personaContext';
import { ProfileContext } from '../../profile/lib/profileContext';
import ProfileThumbnail from '../../profile/component/profileThumbnail';
import { AuthContext } from '../../auth/lib/authContext';
import InsightTags from '../../insight/components/insightTags';
import { MdSubdirectoryArrowRight } from 'react-icons/md';
import useTranslation from '../../lib/i18n/useTranslation';
export default function PersonaListItem(props) {
  const { t } = useTranslation();
  const { insightsCount } = props
  const { persona } = useContext(PersonaContext);
  const { profile } = useContext(ProfileContext);
  const authContext = useContext(AuthContext);
  return (
    <Flex
      flexDirection={"row"}
      alignItems={"center"}
    >
      <Flex
        alignItems="center"
        w={"100%"}
        px={3}
        py={3}
        backgroundColor="white"
        role="group"
        _hover={{
          background: "background.grey",
        }}
      >
        <Flex
          alignItems='center'
          width={"100%"}
          maxWidth="350px"
        >
          <Flex flexShrink={"0"}>
            <PersonaThumbnail size={40} />
          </Flex>
          <Box
            ml={2}
            width={"100%"}
          >
            <Text
              fontSize={16}
              w={"100%"}
              noOfLines={"1"}
            >{persona.name}</Text>
          </Box>
        </Flex>
        <Tooltip label={t('common.owner')}>
          <Flex
            alignItems={"center"}
            gap={1}
            width={"150px"}
          >
            <ProfileThumbnail size={25} />
            {profile.id === authContext.profile.id &&
              <Text width={"100%"} fontSize={"12px"} noOfLines={1}>{t('common.me')}</Text>
            }
            {profile.id !== authContext.profile.id &&
              <Text width={"100%"} fontSize={"12px"} noOfLines={1}>{profile.pseudo}</Text>
            }
          </Flex>
        </Tooltip>
        <Flex 
        flex={1}
        justifyContent={"flex-end"}>
        {insightsCount && (
          <InsightTags
            nbPostiveFeedback={insightsCount.positive_count}
            nbNegativeFeedback={insightsCount.negative_count}
            nbImprovementFeedback={insightsCount.improvement_count}
            nbBehavior={insightsCount.behavior_count}
            nbMotivation={insightsCount.motivation_count}
          />
        )
        }
        </Flex>
      </Flex>
    </Flex>
  );
}
